export default __webpack_public_path__ + "static/media/gaz.c1259872.svg";